export const isDevMode = () => {
  return import.meta.env.DEV;
};

/** The deployed API, reachable from anywhere -- including a terminal. */
export const PUBLIC_API_ORIGIN = "https://api.iwanna.camp";

/**
 * Get the base URL for the API.
 * In production: https://api.iwanna.camp
 * In development: http://localhost:8000
 */
export const getApiBaseUrl = () => {
  if (isDevMode()) {
    const USE_LIVE_API_FOR_DEV = true;

    return USE_LIVE_API_FOR_DEV
      ? `${window.location.origin}/live-api/`
      : `${window.location.origin}/`;
  }
  return `${PUBLIC_API_ORIGIN}/`;
};
